 document.addEventListener("DOMContentLoaded", function () {
    document.addEventListener("click", function (e) {
      if (!e.target.classList.contains("LoadMoreBtn")) return;

      const btn = e.target;
      const blogHandle = btn.dataset.blog;
      let page = parseInt(btn.dataset.page);

      btn.innerText = "Loading...";
      btn.disabled = true;

      const url = `/blogs/${blogHandle}?view=ajax&page=${page}`;

      fetch(url)
        .then(response => response.text())
        .then(html => {
          html = html.trim();

          if (!html) {
            btn.remove();
            return;
          }

          document.querySelector("#blog-posts-grid")
            .insertAdjacentHTML("beforeend", html);

          btn.dataset.page = page + 1;
          btn.innerText = "View More";
          btn.disabled = false;

          const tempDiv = document.createElement("div");
          tempDiv.innerHTML = html;

          if (tempDiv.children.length < 6) {
            btn.remove();
          }
        })
        .catch(error => {
          console.error(error);
          btn.innerText = "Try Again";
          btn.disabled = false;
        });
    });
  });